import React, { Component } from 'react';

import { Button, Modal, Pagination, Table } from 'react-bootstrap';

import UserAdd from './UserAdd.js';
import UserUpdate from './UserUpdate.js';

import ConfirmDeletePopup from '../Controls/ConfirmDeletePopup.js';

import './UserList.css';
import '../Controls/MusterTableStyle.css';

class UserList extends Component {

    confirmDeletePopup = React.createRef();

    constructor(props) {
        super(props);

        let user = {
            username: "",
            lastLoggin: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            categories: []
        }

        this.state = {
            users: [],
            showAddUser: false,
            pageId: 1,
            startIndex: 0,
            pageSize: 10,
            errMsg: '',
            showUpdateUser: false,
            userToUpdate: user,
            showUploadPopup: false,
            uploadMsg: ''
        };

        this.frmAddUser = React.createRef();
    }

    componentDidMount() {
        this.loadUsers(this.state.startIndex);
    }

    //the one loader every caller shares - mount, the reload after add/delete/import,
    //and the pager.  The offset is a parameter rather than read from state because
    //the pager's setState has not landed yet when it calls this
    loadUsers = (startIndex) => {
        fetch('user_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=" + startIndex + "&pageSize=" + this.state.pageSize
        })
        .then(res => res.json())
        .then((data) => {

            for (var i = 0; i < data.length; i++)
            {
                //the servlet nests the categories as a json string inside the json,
                //and reports "none" as the literal string "null"
                if (data[i].categories !== 'null')
                {
                    data[i].categories = JSON.parse(data[i].categories);
                }
            }

            this.setState({
                users:data
            });
        })
    }

    reloadList = () => {
        this.loadUsers(this.state.startIndex);
    }

    reloadUsers = () => {
        console.log("reload users!");
    }

    handleDownloadXlsx = () => {
        //navigating (rather than fetching) lets the servlet's Content-Disposition
        //attachment header drive the browser's download UI without leaving the page
        window.location.href = 'user_export';
    }

    handleShowUpload = () => {
        this.setState({ showUploadPopup: true, uploadMsg: '' });
    }

    handleCloseUpload = () => {
        this.setState({ showUploadPopup: false });
    }

    uploadXlsxFile = (file) => {
        if (!file) {
            return;
        }

        this.setState({ uploadMsg: 'Uploading...' });

        const formData = new FormData();
        formData.append('file', file);

        fetch('user_import', {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(data => {
            if (data && data[0] && data[0].success === 'true') {
                this.setState({ uploadMsg: data[0].msg });
                this.reloadList();
            }
            else {
                this.setState({ uploadMsg: (data && data[0] && data[0].msg) || 'Upload failed' });
            }
        })
        .catch(() => {
            this.setState({ uploadMsg: 'Upload failed' });
        })
    }

    handleUploadFileSelected = (e) => {
        const file = e.target.files[0];
        e.target.value = '';    //so picking the same file again re-triggers onChange
        this.uploadXlsxFile(file);
    }

    handleUploadDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.uploadXlsxFile(e.dataTransfer.files[0]);
    }

    handleUploadDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    renderUploadModal = () => {
        return (
            <Modal
            show={this.state.showUploadPopup}
            onHide={this.handleCloseUpload}
            backdrop="static"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Upload XLSX</h1></center></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    onDrop={this.handleUploadDrop}
                    onDragOver={this.handleUploadDragOver}
                    style={{ border: '2px dashed #282c34', borderRadius: '0.5rem', padding: '2rem', textAlign: 'center', marginBottom: '1rem' }}
                >
                    Drag &amp; drop an .xlsx file here
                </div>
                <center><input type="file" accept=".xlsx" onChange={this.handleUploadFileSelected} /></center>
            </Modal.Body>
            <Modal.Footer>
                <span className="userAddErr">{this.state.uploadMsg}</span>
                <Button onClick={this.handleCloseUpload}>Close</Button>
            </Modal.Footer>
            </Modal>
        );
    }

    handleDelete = username => event => {
        event.preventDefault();
        this.confirmDeletePopup.current.request(() => this.performDelete(username));
    }

    performDelete = (username) => {

        fetch('user_delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "username=" + username
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].delete)
            {
                this.loadUsers(this.state.startIndex);
            }
        })
        .catch(console.log)
    }

    showUpdateUser = (user) => {
        console.log("Show update user");
        console.log(user);
        this.setState({
            userToUpdate: user,
            showUpdateUser: true,
            errMsg: ''
        });
    }

    hideUpdateUser = () => {
        this.setState({
            showUpdateUser: false,
            errMsg: ''
        });
    }

    handleUpdateUser = () => {
        let userToUpdate = this.state.userToUpdate;

        //console.log("updateUser");
        //console.log(userToUpdate);

        this.setState({
            showUpdateUser: false,
            errMsg: ''
        });

        var categoryString = "";
        for (var i = 0; i < userToUpdate.categories.length; i++)
        {
            categoryString += userToUpdate.categories[i].categoryId + ",";
        }
        categoryString = categoryString.substring(0, categoryString.length-1);

        fetch('user_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "username=" + userToUpdate.username +
                  "&firstName=" + userToUpdate.firstName +
                  "&lastName=" + userToUpdate.lastName +
                  "&email=" + userToUpdate.email +
                  "&phone=" + userToUpdate.phone +
                  "&categories=" + categoryString
        })
        .then(res => res.json())
        .then(data =>
        {
        })
        .catch(console.log)

    }

    handleUserUpdateFirstName = (e) => {
        let user = this.state.userToUpdate;
        user.firstName = e.target.value;
        this.setState({
            userToUpdate: user
        });
    }

    handleUserUpdateLastName = (e) => {
        let user = this.state.userToUpdate;
        user.lastName = e.target.value;
        this.setState({
            userToUpdate: user
        });
    }

    handleUserUpdateEmail = (e) => {
        let user = this.state.userToUpdate;
        user.email = e.target.value;
        this.setState({
            userToUpdate: user
        });
    }

    handleUserUpdatePhone = (e) => {
        let user = this.state.userToUpdate;
        user.phone = e.target.value;
        this.setState({
            userToUpdate: user
        });
    }

    handleUserUpdateCategories = (e) => {
        //console.log("handleUserUpdateCategories");
        //console.log(e);
        let user = this.state.userToUpdate;
        var categories = [];

        for (var i = 0; i < e.length; i++)
        {
            var opt = {
                categoryId: e[i].value,
                title: e[i].label
            };

            categories.push(opt);
        }

        user.categories = categories;
        this.setState({
            userToUpdate: user
        });
    }


    renderListData = () => {
        return this.state.users.map((user) => (
            <tr class="blankBody">
                <td class="blankCell"></td>
                <td onClick={() => this.showUpdateUser(user)}>{user.username}</td>
                <td>{user.lastLoggin}</td>
                <td><form class="form-inline" name="frmLogout" onSubmit={this.handleDelete(user.username)}><Button className="btnUser" size="lg" type="submit">Delete</Button><input type="hidden" name="filename" value={user.username} /></form></td>
                <td class="blankCell"></td>
            </tr>
        ));
    }

    handleAddUser = () => {
        this.setState({
            showAddUser: true,
            errMsg: ''
        });
    }

    handleCloseAddUser = () => {
        this.setState({ showAddUser: false });
    }

    handleSubmitAddUser = () => {
        //console.log("Submitting user!");
        //console.log(this.frmAddUser.current.GetUsername());

        fetch('user_add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "username=" + this.frmAddUser.current.GetUsername() + "&password=" + this.hash(this.frmAddUser.current.GetPassword()) + "&firstName=" + this.frmAddUser.current.GetFirstname() + "&lastName=" + this.frmAddUser.current.GetLastname() + "&email=" + this.frmAddUser.current.GetEmail() + "&phone=" + this.frmAddUser.current.GetPhone()
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].add)
            {
                this.setState({ showAddUser: false });
                this.props.reloadUsers();
            }
            else
            {
                this.setState({
                    errMsg: data[0].msg
                });
            }
        })
    }

    renderPagination = () => {
        //numUsers arrives from user_stats as a string, so let the division coerce it
        let numPages = Math.ceil(this.props.numUsers / this.state.pageSize);
        let items = [];
        let active = this.state.pageId;

        var iStart = active - 5;
        var iFinish = active + 5;

        if (iStart < 1)
            iStart = 1;

        if (iFinish > numPages)
            iFinish = numPages;

        //for (let number = 1; number <=numPages; number++)
        for (let number = iStart; number <=iFinish; number++)
        {
            items.push(
                <Pagination.Item className="pageEvents" key={number} active={number === active}>
                {number}
                </Pagination.Item>,
            );
        }

        return (
            <Pagination onClick={this.loadPage}>{items}</Pagination>
        )
    }

    loadPage = e => {
        if (typeof e.target.text !== "undefined")
        {
            let newPageId = parseInt(e.target.text);
            let newStartIndex = (newPageId-1) * this.state.pageSize;

            this.setState({
                pageId: newPageId,
                startIndex: newStartIndex
            });

            this.loadUsers(newStartIndex);
        }
    }


    hash = (inputString) => {
        var hc="0123456789abcdef";
        function rh(n) {var j,s="";for(j=0;j<=3;j++) s+=hc.charAt((n>>(j*8+4))&0x0F)+hc.charAt((n>>(j*8))&0x0F);return s;}
        function ad(x,y) {var l=(x&0xFFFF)+(y&0xFFFF);var m=(x>>16)+(y>>16)+(l>>16);return (m<<16)|(l&0xFFFF);}
        function rl(n,c)            {return (n<<c)|(n>>>(32-c));}
        function cm(q,a,b,x,s,t)    {return ad(rl(ad(ad(a,q),ad(x,t)),s),b);}
        function ff(a,b,c,d,x,s,t)  {return cm((b&c)|((~b)&d),a,b,x,s,t);}
        function gg(a,b,c,d,x,s,t)  {return cm((b&d)|(c&(~d)),a,b,x,s,t);}
        function hh(a,b,c,d,x,s,t)  {return cm(b^c^d,a,b,x,s,t);}
        function ii(a,b,c,d,x,s,t)  {return cm(c^(b|(~d)),a,b,x,s,t);}
        function sb(x) {
            var i;var nblk=((x.length+8)>>6)+1;var blks=new Array(nblk*16);for(i=0;i<nblk*16;i++) blks[i]=0;
            for(i=0;i<x.length;i++) blks[i>>2]|=x.charCodeAt(i)<<((i%4)*8);
            blks[i>>2]|=0x80<<((i%4)*8);blks[nblk*16-2]=x.length*8;return blks;
        }
        var i,x=sb(""+inputString),a=1732584193,b=-271733879,c=-1732584194,d=271733878,olda,oldb,oldc,oldd;
        for(i=0;i<x.length;i+=16) {olda=a;oldb=b;oldc=c;oldd=d;
            a=ff(a,b,c,d,x[i+ 0], 7, -680876936);d=ff(d,a,b,c,x[i+ 1],12, -389564586);c=ff(c,d,a,b,x[i+ 2],17,  606105819);
            b=ff(b,c,d,a,x[i+ 3],22,-1044525330);a=ff(a,b,c,d,x[i+ 4], 7, -176418897);d=ff(d,a,b,c,x[i+ 5],12, 1200080426);
            c=ff(c,d,a,b,x[i+ 6],17,-1473231341);b=ff(b,c,d,a,x[i+ 7],22,  -45705983);a=ff(a,b,c,d,x[i+ 8], 7, 1770035416);
            d=ff(d,a,b,c,x[i+ 9],12,-1958414417);c=ff(c,d,a,b,x[i+10],17,     -42063);b=ff(b,c,d,a,x[i+11],22,-1990404162);
            a=ff(a,b,c,d,x[i+12], 7, 1804603682);d=ff(d,a,b,c,x[i+13],12,  -40341101);c=ff(c,d,a,b,x[i+14],17,-1502002290);
            b=ff(b,c,d,a,x[i+15],22, 1236535329);a=gg(a,b,c,d,x[i+ 1], 5, -165796510);d=gg(d,a,b,c,x[i+ 6], 9,-1069501632);
            c=gg(c,d,a,b,x[i+11],14,  643717713);b=gg(b,c,d,a,x[i+ 0],20, -373897302);a=gg(a,b,c,d,x[i+ 5], 5, -701558691);
            d=gg(d,a,b,c,x[i+10], 9,   38016083);c=gg(c,d,a,b,x[i+15],14, -660478335);b=gg(b,c,d,a,x[i+ 4],20, -405537848);
            a=gg(a,b,c,d,x[i+ 9], 5,  568446438);d=gg(d,a,b,c,x[i+14], 9,-1019803690);c=gg(c,d,a,b,x[i+ 3],14, -187363961);
            b=gg(b,c,d,a,x[i+ 8],20, 1163531501);a=gg(a,b,c,d,x[i+13], 5,-1444681467);d=gg(d,a,b,c,x[i+ 2], 9,  -51403784);
            c=gg(c,d,a,b,x[i+ 7],14, 1735328473);b=gg(b,c,d,a,x[i+12],20,-1926607734);a=hh(a,b,c,d,x[i+ 5], 4,    -378558);
            d=hh(d,a,b,c,x[i+ 8],11,-2022574463);c=hh(c,d,a,b,x[i+11],16, 1839030562);b=hh(b,c,d,a,x[i+14],23,  -35309556);
            a=hh(a,b,c,d,x[i+ 1], 4,-1530992060);d=hh(d,a,b,c,x[i+ 4],11, 1272893353);c=hh(c,d,a,b,x[i+ 7],16, -155497632);
            b=hh(b,c,d,a,x[i+10],23,-1094730640);a=hh(a,b,c,d,x[i+13], 4,  681279174);d=hh(d,a,b,c,x[i+ 0],11, -358537222);
            c=hh(c,d,a,b,x[i+ 3],16, -722521979);b=hh(b,c,d,a,x[i+ 6],23,   76029189);a=hh(a,b,c,d,x[i+ 9], 4, -640364487);
            d=hh(d,a,b,c,x[i+12],11, -421815835);c=hh(c,d,a,b,x[i+15],16,  530742520);b=hh(b,c,d,a,x[i+ 2],23, -995338651);
            a=ii(a,b,c,d,x[i+ 0], 6, -198630844);d=ii(d,a,b,c,x[i+ 7],10, 1126891415);c=ii(c,d,a,b,x[i+14],15,-1416354905);
            b=ii(b,c,d,a,x[i+ 5],21,  -57434055);a=ii(a,b,c,d,x[i+12], 6, 1700485571);d=ii(d,a,b,c,x[i+ 3],10,-1894986606);
            c=ii(c,d,a,b,x[i+10],15,   -1051523);b=ii(b,c,d,a,x[i+ 1],21,-2054922799);a=ii(a,b,c,d,x[i+ 8], 6, 1873313359);
            d=ii(d,a,b,c,x[i+15],10,  -30611744);c=ii(c,d,a,b,x[i+ 6],15,-1560198380);b=ii(b,c,d,a,x[i+13],21, 1309151649);
            a=ii(a,b,c,d,x[i+ 4], 6, -145523070);d=ii(d,a,b,c,x[i+11],10,-1120210379);c=ii(c,d,a,b,x[i+ 2],15,  718787259);
            b=ii(b,c,d,a,x[i+ 9],21, -343485551);a=ad(a,olda);b=ad(b,oldb);c=ad(c,oldc);d=ad(d,oldd);
        }
        return rh(a)+rh(b)+rh(c)+rh(d);
    }

    render() {
        return (
            <div>

            <Modal
              show={this.state.showAddUser}
              onHide={this.handleCloseAddUser}
              backdrop="static"
              centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Add New User</h1></center></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <UserAdd ref={this.frmAddUser} reloadUsers={this.reloadUsers} />
            </Modal.Body>

            <Modal.Footer>
                <span className="userAddErr">{this.state.errMsg}</span>
                <Button onClick={this.handleSubmitAddUser}>Add</Button>
                <Button onClick={this.handleCloseAddUser}>Close</Button>
            </Modal.Footer>
            </Modal>

            <UserUpdate
            showUpdateUser={this.state.showUpdateUser}
            hideUpdateUser={this.hideUpdateUser}
            handleUpdateUser={this.handleUpdateUser}
            userToUpdate={this.state.userToUpdate}
            handleUserUpdateFirstName={this.handleUserUpdateFirstName}
            handleUserUpdateLastName={this.handleUserUpdateLastName}
            handleUserUpdateEmail={this.handleUserUpdateEmail}
            handleUserUpdatePhone={this.handleUserUpdatePhone}
            handleUserUpdateCategories={this.handleUserUpdateCategories}>
            </UserUpdate>

            <div class="paginationUsers">{this.renderPagination()}</div>
            <Table className="tblRecordingFiles musterStyleTable">
            <thead>
                <tr>
                    <th class="userAbsorbingColumn"></th>
                    <th><h3>User</h3></th>
                    <th><h3>Last Login</h3></th>
                    <th><h3>Action</h3></th>
                    <th class="userAbsorbingColumn"></th>
                </tr>
            </thead>
            {this.renderListData()}
            </Table>

            <div className="userListActions">
            <Button onClick={this.handleAddUser} className="btnUser">
            Add User
            </Button>
            <Button onClick={this.handleDownloadXlsx} className="btnUser">Download XLSX</Button>
            <Button onClick={this.handleShowUpload} className="btnUser">Upload XLSX</Button>
            </div>

            {this.renderUploadModal()}
            <ConfirmDeletePopup ref={this.confirmDeletePopup} />

            </div>
        )
    }
}

export default UserList;
